export default "__VITE_PUBLIC_ASSET__02c2917e__"